import React from 'react';
import { Alert, Button, Card, Descriptions, Tag } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';

/**
 * Présente la décision de rentabilité avant la création des textes et visuels. La
 * validation déclenche seulement les créas ; elle n'envoie rien à Meta.
 */
const MetaAdsStrategyReview = ({ strategy, currency, onContinue, generating }) => (
  <Card title="1. Stratégie proposée — à valider" className="shadow-sm">
    <p>{strategy.summary}</p>
    {strategy.marketValues?.length > 0 && <Alert className="mb-4" type="info" showIcon message="Valeurs du marché cible" description={strategy.marketValues.join(' · ')} />}
    {strategy.creativeAngles?.map((angle, index) => (
      <Card key={index} size="small" className="mb-3" title={`Angle ${index + 1} — ${angle.name}`}>
        <p><strong>Pourquoi :</strong> {angle.reason}</p>
        <p className="mb-0"><strong>Brief visuel :</strong> {angle.visualBrief}</p>
      </Card>
    ))}
    {strategy.revenuePlan && <Alert className="mb-4" type="success" showIcon message="Plan de revenu" description={strategy.revenuePlan} />}
    {strategy.warnings?.map((warning, index) => <Alert key={index} className="mb-2" type="warning" showIcon message={warning} />)}
    <Descriptions bordered size="small" column={1} className="mb-4">
      {strategy.adSets.map((set, index) => (
        <Descriptions.Item key={index} label={`Ensemble ${index + 1}`}>
          <strong>{set.dailyBudget} {currency} / jour</strong> · <Tag>{set.audienceStrategy}</Tag><br />{set.reason}
        </Descriptions.Item>
      ))}
    </Descriptions>
    <Button type="primary" icon={<CheckCircleOutlined />} loading={generating} onClick={onContinue}>Valider la stratégie et créer les annonces</Button>
  </Card>
);

export default MetaAdsStrategyReview;
